import React, { PropsWithChildren } from 'react';

import { FlowProvider } from 'react-flow-app';

import { TestCoreComponent, TestCoreComponentProps } from '@bcp-channels-sharedcomponents-reactjs/core';
import { Company, Language, Platform } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';
import { ThemeProvider } from '@bcp-nextgen-dx-component-factory/design-system';
import { Accolade } from '@bcp-nextgen-dx-component-factory/theme-accolade';
import { flowManager } from '@flows';

export interface TestComponentProps {
	coreProps?: TestCoreComponentProps;
}

export const TestComponent: React.FC<PropsWithChildren<TestComponentProps>> = ({ children, coreProps }) => {
	coreProps = coreProps
		? coreProps
		: {
				company: Company.bcp,
				language: Language.pt,
				platform: Platform.mobile,
		  };

	return (
		<ThemeProvider theme={Accolade}>
			<FlowProvider fm={flowManager} initialFlowName="clPublicSimulator">
				<TestCoreComponent data-test="test-component" {...coreProps}>
					{children}
				</TestCoreComponent>
			</FlowProvider>
		</ThemeProvider>
	);
};
